if (!customElements.get('sb-sticky-cta')) {
  customElements.define('sb-sticky-cta', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };

      const options = { passive: true, signal: this.abort.signal };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      window.visualViewport?.addEventListener('resize', this.schedule, options);
      window.visualViewport?.addEventListener('scroll', this.schedule, options);
      document.addEventListener('focusin', this.schedule, options);
      document.addEventListener('focusout', this.schedule, options);

      this.resizeObserver = new ResizeObserver(this.schedule);
      const main = document.getElementById('MainContent');
      if (main) this.resizeObserver.observe(main);

      this.update();
    }

    update() {
      const viewport = window.visualViewport;
      const viewportTop = viewport ? viewport.offsetTop : 0;
      const viewportBottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;

      const narrow = matchMedia('(max-width: ' + this.dataset.breakpoint + 'px)').matches;
      const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');

      const hero = document.querySelector('[data-section-type="sb-bold-hero"]');
      const footer = document.querySelector('footer');

      const passedHero = hero
        ? hero.getBoundingClientRect().bottom <= viewportTop + 8
        : window.scrollY > 240;

      const footerReached = footer
        ? footer.getBoundingClientRect().top <= viewportBottom + 8
        : false;

      this.hidden = !narrow || typing || !passedHero || footerReached;

      // iOS Safari / Visual Viewport: Banner oberhalb der Browserleiste halten.
      this.style.setProperty(
        '--sb-viewport-bottom',
        Math.max(0, window.innerHeight - viewportBottom) + 'px'
      );
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
